import RequirePan from "../components/common/RequirePan";




export const withPanGuard = (element) => <RequirePan>{element}</RequirePan>;
